import { useEvent } from '~features/events/hooks/useEvent';
import type { FiltersEventMap } from '~components/Filters/FiltersEvents';

const Events = {
  PageViewed: 'CDN Analytics Viewed',
  TableFiltersChanged: 'CDN Analytics: Crawler Requests Filters Changed',
  TableFiltersCleared: 'CDN Analytics: Crawler Requests Filters Cleared',
  ExportRequested: 'CDN Analytics: Export Requested',
  ChartToggled: 'CDN Analytics: Chart Toggled',
  CrawlerSelected: 'CDN Analytics: Crawler Selected',
  CrawlerPickerOpened: 'CDN Analytics: Crawler Picker Opened',
  DomainSelected: 'CDN Analytics: Domain Selected',
  TimeframeSelected: 'CDN Analytics: Timeframe Selected',
  PresetClicked: 'CDN Analytics: Preset Clicked',
  PeriodStepped: 'CDN Analytics: Period Stepped',
  PeriodReset: 'CDN Analytics: Period Reset',
  ChartDatasetToggled: 'CDN Analytics: Chart Dataset Visibility',
  ChartDescriptionsToggled: 'CDN Analytics: Chart Descriptions Toggled',
  ExportAsPdf: 'CDN Analytics: Export as PDF',
} as const;

type Event = keyof typeof Events;
type EventProperties = Record<string, unknown>;
type EventPayloadMap = FiltersEventMap & {
  PageViewed: EventProperties & { version: string };
  TableFiltersChanged: EventProperties;
  TableFiltersCleared: Record<string, never>;
  ExportRequested: EventProperties;
  ChartToggled: { chart_type: string };
  ChartDatasetToggled: { chart: string; dataset: string; action: 'hide' | 'show' };
};

function useTrackCDNAnalyticsEvent() {
  const { track } = useEvent();
  function useTrackCDNAnalyticsEvent<E extends keyof FiltersEventMap>(event: E, data: FiltersEventMap[E]): void;
  function useTrackCDNAnalyticsEvent<E extends Event>(event: E, data: EventPayloadMap[E]): void;
  function useTrackCDNAnalyticsEvent(event: Event, data: EventPayloadMap[Event]): void {
    const refinedData: EventProperties = { ...data };

    track(Events[event], refinedData);
  }

  return useTrackCDNAnalyticsEvent;
}

export default useTrackCDNAnalyticsEvent;
